module.exports = __webpack_public_path__ + "static/teacher-presence-24b8ea0d6c69c7c230a7099bf5063e46.jpg";